import { StringParam, withDefault } from 'use-query-params';
import { SchemaFilterType, SortDir } from '@ui/src';

export const feesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Name',
  },
  {
    name: 'currency',
    label: 'Curreny',
  },
  {
    name: 'feeAmountType',
    label: 'Write-off type',
  },
  {
    name: 'writeOffValue',
    label: 'Write-off value',
  },
];

export const feesDefaultSorter = {
  sortProp: feesColumns[0].name,
  sortDir: SortDir.ASC,
};

export const feesSchema = {
  sortProp: {
    value: withDefault(StringParam, feesDefaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, feesDefaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};
